/* eslint-disable unicorn/no-null */
import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import styles from './accommodation-blocking-direction.module.scss';

export type IAccommodationBlockingDirection = 'outbound' | 'inbound' | null;

interface IAccommodationBlockingDirectionProperties {
  value: IAccommodationBlockingDirection;
  visible: boolean;
  onChange: (value: IAccommodationBlockingDirection) => void;
}

const DIRECTION_OPTIONS: { label: string; value: IAccommodationBlockingDirection }[] = [
  { label: 'Inbound', value: 'inbound' },
  { label: 'Outbound', value: 'outbound' },
];

function AccommodationBlockingDirection({ value, visible, onChange }: IAccommodationBlockingDirectionProperties) {
  const wasVisible = useRef(visible);

  useEffect(() => {
    if (!wasVisible.current && visible) {
      onChange('outbound');
    } else if (wasVisible.current && !visible) {
      onChange(null);
    }
    wasVisible.current = visible;
  }, [visible, onChange]);

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.field}>
      <label htmlFor="accommodationBlockingDirection">Direction</label>
      <Dropdown
        id="accommodationBlockingDirection"
        value={value}
        options={DIRECTION_OPTIONS}
        onChange={(event) => onChange(event.value)}
        placeholder="Select Direction"
        showClear
      />
    </div>
  );
}

export default AccommodationBlockingDirection;
